export default "__VITE_ASSET__QIRxlfIw__"